
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-ebab04be&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ZipAndAge.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ZipAndAge.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-ebab04be!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ZipAndAge.vue"),
  /* scopeId */
  "data-v-ebab04be",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/start/ZipAndAge.vue
// module id = 81
// module chunks = 1